import { Moment } from "moment";

export default class ExercicioDireito implements IExercicioDireito {
  public id!: string;
  public codigoAtivo!: string;
  public codigoObjeto!: string;
  public isinDireito!: string;
  public dataExercicio!: Moment;
  public quantidade!: number;
  public precoUnitario!: number;

  constructor(param: IExercicioDireito) {
    Object.assign(this, param);
  }
}

interface IExercicioDireito {
  id: string;
  codigoAtivo: string;
  codigoObjeto: string;
  isinDireito: string;
  dataExercicio: Moment;
  quantidade: number;
  precoUnitario: number;
}
